import axios from '@axios'

export default {
  getLockeds(page, field) {
    return axios.post(`admin/locks/list?page=${page}`, field)
  },

}
